import { InnerNavigatorOption } from 'components/ui/InnerNavigator';
import { usePermissions } from 'hooks';

export function InnerOptions() {
  const { checkUserPermission } = usePermissions();
  const options: InnerNavigatorOption[] = [
    {
      title: 'Usuário Checklist',
      route: '/settings/hub-checklist-user',
      hasPermission: checkUserPermission('accessConfigurator'),
    },
    {
      title: 'Novo Usuário Checklist',
      route: '/settings/hub-checklist-user/new',
      hasPermission: checkUserPermission('accessConfigurator'),
    },
  ];

  return { options };
}
